//  @flow

import React from 'react';
import { useTranslation } from 'react-i18next';

import { CourseData } from '../../GlobalTypes';

import Heading from '../../Components/Heading';
import ListGroup from '../../Components/ListGroup';
import CourseCard from '../../Components/CourseCard';
import Button from '../../Components/Button';

type CourseProps = {|
  courses: Array<CourseData>
|};

const Course = (props: CourseProps) => {
  const { courses, onCourseClick, onCoursesClick } = props;
  const { t } = useTranslation();
  return (
    <ListGroup
      containerClassName="home-course-container"
      title={<Heading title={t('coursesHeading')} />}
      ListFooterComponent={
        <div className="home-courses-footer">
          <Button onClick={onCoursesClick} primary text={t('allCoursesLink')} />
        </div>
      }
      count={3}
      maxElements={3}>
      {courses.map((course, index) => (
        <CourseCard
          hidden={index > 2}
          position={index}
          onCourseClick={onCourseClick}
          key={`${course.id}_${index}`}
          buttonText="VIEW DETAILS"
          {...course}
        />
      ))}
    </ListGroup>
  );
};

export default Course;



// WEBPACK FOOTER //
// ./src/Pages/Home/Courses.js